import { render, staticRenderFns } from "./RegistrodeIncidentes.vue?vue&type=template&id=dbea9e6c&"
import script from "./RegistrodeIncidentes.vue?vue&type=script&lang=js&"
export * from "./RegistrodeIncidentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports